(function (ng) {
    //service that maintains the state for a customer's package

    ng.module('evo.Packages.Services').factory('customerPackageService', ['$location',
        function ($location) {
            return {
                getCustomerPackage: function () {
                    var pkg = {
                        PackageBucketId: 0,
                        SelectedItemIds: []
                    };

                    var queryStringParams = $location.search();
                    if (queryStringParams) {
                        pkg.PackageBucketId = Number(queryStringParams.PackageBucketId) || 0;

                        if (queryStringParams.SelectedItemIds) {
                            var itemIds = queryStringParams.SelectedItemIds;
                            if (!$.isArray(itemIds)) {
                                itemIds = [itemIds];
                            }
                            pkg.SelectedItemIds = itemIds.map(Number);
                        }
                    }

                    return pkg;
                },
                setPackageItems: function (itemIds) {
                    var pkg = {
                        PackageBucketId: $location.search()['PackageBucketId'] || 0,
                        SelectedItemIds: itemIds || []
                    };

                    //set the new query string values, but replace the url -- don't add a new history entry
                    $location.search(pkg).replace();
                }
            };
        }
    ]);
})(angular);